import type { NewsItem } from "@/lib/data/types";

export function formatRelativeDate(iso: string | undefined): string | undefined {
  if (!iso) return undefined;
  const date = new Date(iso);
  const diffMs = Date.now() - date.getTime();
  const diffHours = Math.round(diffMs / (60 * 60 * 1000));
  if (diffHours < 1) return "vor wenigen Minuten";
  if (diffHours < 24) return `vor ${diffHours} Std.`;
  const diffDays = Math.round(diffHours / 24);
  if (diffDays < 7) return `vor ${diffDays} Tag${diffDays === 1 ? "" : "en"}`;
  return date.toLocaleDateString("de-DE", { day: "2-digit", month: "short", year: "numeric" });
}

export function NewsList({ news }: { news: NewsItem[] }) {
  if (news.length === 0) {
    return <p className="text-sm text-muted-foreground">Aktuell keine News verfügbar.</p>;
  }

  return (
    <div className="flex flex-col">
      {news.map((item, i) => (
        <a
          key={`${item.link}-${i}`}
          href={item.link}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-4 border-b border-hairline py-3 text-sm last:border-0 hover:bg-muted/50"
        >
          {item.thumbnailUrl && (
            // eslint-disable-next-line @next/next/no-img-element -- externe, unbekannte Bildhosts, kein next/image-Whitelisting pro Publisher moeglich.
            <img
              src={item.thumbnailUrl}
              alt=""
              className="h-14 w-14 shrink-0 rounded object-cover"
            />
          )}
          <div className="min-w-0 flex-1">
            <div className="line-clamp-2 font-medium text-ink">{item.title}</div>
            <div className="mt-1 text-xs text-muted-foreground">
              {item.publisher}
              {item.publisher && item.publishedAt && " · "}
              {formatRelativeDate(item.publishedAt)}
            </div>
          </div>
        </a>
      ))}
    </div>
  );
}
